<template>
  <div
    class="flex items-center justify-between gap-3 overflow-hidden rounded-md bg-white shadow transition-all select-none"
    :class="{
      'cursor-pointer hover:shadow-md': interactive,
      'px-1 py-2 md:px-6 md:py-3': !dense,
      'px-1 py-1 md:px-2': dense,
    }"
  >
    <div class="flex-1">
      <slot />
    </div>
    <slot name="after" />
  </div>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ dense?: boolean; interactive?: boolean }>(), {
  dense: false,
  interactive: true,
});
</script>
